<template>
  <el-card shadow="hover">
    <el-table :data="workData" style="width: 100%">
      <el-table-column
          prop="question"
          label="问题">
      </el-table-column>
      <el-table-column
          prop="content"
          label="解决办法">
          <template slot-scope="scope">
              <div v-html="scope.row.content"></div>
          </template>
      </el-table-column>
    </el-table>
  </el-card>
</template>
<script>
export default {
  name: "Question",
  data() {
    return {
      workData: [
        {
          question: '',
          content: ''
        },
        {
          question: '无法加载文件 C:\Users\Administrator\AppData\Roaming\npm\tsc.ps1,因为在此系统上禁止运行脚本',
          content: '​以管理员身份运行powerShell，输入以下命令：set-ExecutionPolicy RemoteSigned，输入Y ，问题解决。wx9b3bb2a8f58e672d'
        }]
    }
  }
}
</script>